module.exports = __webpack_public_path__ + "img/PLATA.37082733.png";